import React, { memo } from 'react';
import { prop } from 'ramda';
import { useDeviceSelector } from '@core/js/store/hooks';
import { Carousel } from '@core/js/components/common/Carousel';
import { CATEGORY_VIEWS, LAYOUT_SIZES } from '@core/js/hooks/games/types';
import { defaultOptions } from '@theme/js/components/common/Carousel/constants';

import { Game } from '@core/js/components/main/GamesGrid/components/Game';
import * as Types from '@core/js/components/main/GamesGrid/components/GamesCarouselView/types';
import * as helpers from '@core/js/components/main/GamesGrid/components/GamesCarouselView/helpers';
import { GamesHeader } from '@core/js/components/main/GamesGrid/components/GamesHeader';
import { gameTileRatio } from '@core/js/components/main/GamesGrid/helpers';
import { CAROUSEL_GAP, CAROUSEL_BORDER_RADIUS, CAROUSEL_IMAGE_LAYOUT } from '@core/js/components/main/GamesGrid/components/GamesCarouselView/constants';

import style from './GamesCarouselView.scss';

export const GamesCarouselViewBare: React.FC<Types.IGamesCarouselViewProps> = (props) => {
    const {
        categoryView, feedName, categoryName, games, allGamesCount, categoryRowsCount, categoryLayoutWithGames,
        carouselTileSize = LAYOUT_SIZES.square, carouselGamesNumber = '10', carouselGamesNumberInRow = '5',
        isShownSliderArrows
    } = props;
    const numeration = categoryView === CATEGORY_VIEWS.top;
    const tailWidth = helpers.getTailWidth(carouselTileSize, numeration);
    const formFactor = useDeviceSelector(prop('formFactor'));

    return (
        <>
            <GamesHeader
                feedName={feedName}
                categoryName={categoryName}
                allGamesCount={allGamesCount}
                categoryRowsCount={categoryRowsCount}
                categoryLayoutWithGames={categoryLayoutWithGames}
            />
            <Carousel
                classNames={style}
                tailWidth={formFactor === 'desktop' ? 0 : tailWidth} // Lugano changes
                numeration={numeration}
                gap={CAROUSEL_GAP[formFactor]}
                navigation={isShownSliderArrows}
                ratio={gameTileRatio(carouselTileSize)}
                totalItems={Number(carouselGamesNumber)}
                itemsPerView={Number(carouselGamesNumberInRow)}
                loop={categoryView === CATEGORY_VIEWS.carousel}
                reserveTailSpace={defaultOptions.reserveTailSpace} // Lugano changes
                className={`cms-games-grid-category-${categoryView} cms-games-grid-category-${feedName}-${categoryName}`}
            >
                {games.map(gameCode => (
                    <Game
                        key={gameCode}
                        width={'100%'}
                        height={'100%'}
                        gameCode={gameCode}
                        size={carouselTileSize}
                        ratio={CAROUSEL_IMAGE_LAYOUT}
                        borderRadius={`${CAROUSEL_BORDER_RADIUS}px`}
                    />
                ))}
            </Carousel>
        </>
    );
};

export const GamesCarouselView = memo(GamesCarouselViewBare);
